import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["x", "y", "width", "height"]
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = ["onUpdate:modelValue", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.cerfa_ && _ctx.cerfa_.values && _ctx.cerfa_.values.length && _ctx.isLoaded && _ctx.fieldsChildLoaded)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          viewBox: "0 0 1240 1754",
          style: _normalizeStyle(_ctx.svgFormStyle)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cerfa_.values, (value, vi) => {
            return (_openBlock(), _createElementBlock("g", { key: vi }, [
              (_openBlock(), _createElementBlock("foreignObject", {
                x: _ctx.getX(value),
                y: _ctx.getY(value),
                width: _ctx.getWidth(value),
                height: _ctx.getHeight(value)
              }, [
                (!_ctx.fieldsChild_ || !_ctx.fieldsChild_[value.key])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(value.key), 1))
                  : (
                                value.key === 'NEANT' ||
                                (_ctx.selectorOfKey(value.key) && _ctx.isCheckbox(_ctx.selectorOfKey(value.key)))
                            )
                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                        key: 1,
                        modelValue: _ctx.fieldsChild_[value.key].displayValue,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.fieldsChild_[value.key].displayValue) = $event),
                        readonly: value.key === 'NEANT' || _ctx.isReadonly(value.key),
                        "true-value": "X",
                        "false-value": "",
                        "hide-details": "",
                        class: "ma-0 pa-0 custom-checkbox-taxform-png",
                        ripple: false,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSpecManager()))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                    : (_ctx.selectorOfKey(value.key))
                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                          key: 2,
                          modelValue: _ctx.fieldsChild_[value.key].displayValue,
                          "onUpdate:modelValue": [
                            ($event: any) => ((_ctx.fieldsChild_[value.key].displayValue) = $event),
                            _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSpecManager()))
                          ],
                          readonly: _ctx.isReadonly(value.key),
                          "hide-details": "",
                          items: _ctx.getSelectorValuesFile(_ctx.selectorOfKey(value.key)),
                          class: "text-field-for-tax-form",
                          "item-title": "text",
                          "item-value": "value"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "items"]))
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 3,
                          "onUpdate:modelValue": [
                            ($event: any) => ((_ctx.fieldsChild_[value.key].displayValue) = $event),
                            _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSpecManager()))
                          ],
                          "hide-details": "",
                          readonly: _ctx.isReadonly(value.key),
                          class: _normalizeClass(
                                _ctx.justifyInputRight(value.key)
                                    ? 'oss-text-field-for-tax-form oss-text-field-justify-end'
                                    : 'oss-text-field-for-tax-form'
                            )
                        }, null, 10, _hoisted_3)), [
                          [_vModelText, _ctx.fieldsChild_[value.key].displayValue]
                        ])
              ], 8, _hoisted_1))
            ]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}